/*!
 * mhead.js
 * mmenu.frebsite.nl/mhead
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-4.0
 * http://creativecommons.org/licenses/by/4.0/
 */

import Mhead from '../dist/core/mhead.core';

if (window) {
    //	Global namespace
    window.Mhead = Mhead;

    //	jQuery plugin
    (function ($) {
        if ($) {
            $.fn.mhead = function (options) {
                return this.each((e, element) => {
                    new Mhead(element, options);
                });
            };
        }
    })(window.jQuery || window.Zepto || null);
}



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mhead-js/src/mhead.js
// module id = 94
// module chunks = 0